import React from 'react'

export function TimeLineContainer({children}) {
  return <footer className='timeline_footer'>
    {children}
  </footer>
}